import React, { Component, PropTypes } from 'react';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import FontPropertySelect from './FontPropertySelect';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import { connect } from 'react-redux';

class FilterBarStyles extends Component {
    render() {
        return (
            <div className="FilterBarStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-8">
                        <ReactSparkSelectInput
                            label="Font Family"
                            onChange={this.props.onFontChange(this.props.tagName)}
                            defaultValue={this.props.font}
                            values={this.props.availableFonts.map(v => {
                                return { key: v, label: v };
                            })}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <PresetColorPicker
                            color={this.props.color}
                            onColorChange={this.props.onFontColorChange(this.props.tagName)}
                        />
                    </div>
                    <FontPropertySelect
                        label="Font Size"
                        defaultValue={this.props.fontData.size}
                        values={this.props.availableFontSizes}
                        onChange={this.props.onFontSizeChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Font Weight"
                        defaultValue={this.props.fontData.weight}
                        values={this.props.availableFontWeights[this.props.fontData.font]}
                        onChange={this.props.onFontWeightChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Font Style"
                        defaultValue={this.props.fontData.style}
                        values={this.props.availableFontStyle}
                        onChange={this.props.onFontStyleChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Text Align"
                        defaultValue={this.props.fontData.align}
                        values={this.props.availableTextAlign}
                        onChange={this.props.onTextAlignChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Text Decoration"
                        defaultValue={this.props.fontData.decoration}
                        values={this.props.availableTextDecoration}
                        onChange={this.props.onTextDecorationChange(this.props.tagName)}
                    />
                    <FontPropertySelect
                        label="Line Height"
                        defaultValue={this.props.fontData.lineHeight}
                        values={this.props.availableLineHeight}
                        onChange={this.props.onLineHeightChange(this.props.tagName)}
                    />
                </div>
            </div>
        );
    }
}

FilterBarStyles.propTypes = {
    children: PropTypes.element,
    availableFonts: PropTypes.array,
    availableFontSizes: PropTypes.array,
    availableFontWeights: PropTypes.object,
    availableFontStyle: PropTypes.array,
    availableTextAlign: PropTypes.array,
    availableTextDecoration: PropTypes.array,
    availableLineHeight: PropTypes.array,
    settings: PropTypes.object,
    tagNameName: PropTypes.string
};

FilterBarStyles.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    return { ...state.app.data.theme.filterBar[ownProps.tagName], ...state.theme.filterBar };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontChange: tagName => {
            return event => dispatch(ThemeActions.setFilterBarFont(tagName, event.target.value));
        },
        onFontSizeChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_SIZE,
                    layer: tagName,
                    size: event.target.value
                });
        },
        onFontWeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_WEIGHT,
                    layer: tagName,
                    weight: event.target.value
                });
        },
        onFontStyleChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_STYLE,
                    layer: tagName,
                    style: event.target.value
                });
        },
        onFontColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_THEME_FONT_COLOR,
                    layer: tagName,
                    color: event.target.value
                });
        },
        onTextAlignChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_ALIGN,
                    layer: tagName,
                    align: event.target.value
                });
        },
        onTextDecorationChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_DECORATION,
                    layer: tagName,
                    decoration: event.target.value
                });
        },
        onLineHeightChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_PRIMARY_TEXT_LINE_HEIGHT,
                    layer: tagName,
                    lineHeight: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBarStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/Styles.js